<template>
  <div class="rightContent">
    <div class="tableView" v-if="tableVal=='blueWayOrder'">
      <el-table key="blueWayOrder" stripe border style="width: 100%" height="100%" size="mini"
        :data="tableData" @sort-change="sortChange"
      >
        <el-table-column type="index" align="center"
          :width="pagination.endIndex >= 1000 ? 80 : 50"
          :index="pagination.beginIndex"
        ></el-table-column>
        <el-table-column min-width="120px" 
          label="工单号" prop="aufnr" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="allowSkip" @click="clickAllowSkip(scope.row)">
              {{ scope.row.aufnr }}
            </span>
          </template>
        </el-table-column>
        <el-table-column min-width="110px" 
          label="产品物料" prop="maktx" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.maktx" :content="scope.row.maktx" class="item" effect="dark" placement="top" :open-delay="300">
              <span>
                {{scope.row.matnr ? scope.row.matnr : '-'}}
              </span>
            </el-tooltip>
            <span v-else>{{scope.row.matnr ? scope.row.matnr : '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="80px"
          label="产品型号" prop="model" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>
              {{ scope.row.model ? scope.row.model : "-" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="中类" prop="productType" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>
              {{scope.row.productType ? scope.row.productType : '-'}}
            </span>
          </template>
        </el-table-column>        
        <el-table-column min-width="80px" 
          label="工单数量" prop="psmng" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.psmng">
              {{ scope.row.psmng }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          label="销售订单" prop="kdauf" align="center" show-overflow-tooltip min-width="110px">
          <template slot-scope="scope">
            <span>
              {{ scope.row.kdauf ? scope.row.kdauf : "-" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column min-width="55px" 
          label="客户代码" prop="kunnr" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.vkorg?scope.row.vkorg : '(查询失败)'" class="item" effect="dark" placement="top" :open-delay="300">
              <span>
                {{scope.row.kunnr ? scope.row.kunnr : '-'}}
              </span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column min-width="50px" show-overflow-tooltip
          label="业务员" prop="ktonr" align="center">
          <template slot-scope="scope">
            <span>
              {{ scope.row.ktonr ? scope.row.ktonr : "-" }}
            </span>
          </template>
        </el-table-column>
      </el-table>      
      <pagination :pagination="pagination"
        @currentChange="currentChange"
        @sizeChange="sizeChange"
        @refreshBtn="onSearch"
      ></pagination> 
    </div>
    <div class="tableView" v-else-if="tableVal=='blueWayItemCode'">
      <el-table key="blueWayItemCode" stripe :data="tableData" border style="width: 100%" height="100%" size="mini"
        @sort-change="sortChange" @selection-change="handleSelectionChange"
      >
        <el-table-column type="index" :width="pagination.endIndex >= 1000 ? 80 : 50"
          align="center" :index="pagination.beginIndex"
        ></el-table-column>
        <el-table-column prop="bluWay" label="外协工厂编码" align="center">
          <template slot-scope="scope">          
            <span class="textOverflow">{{ scope.row.bluWay }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="aoni" label="奥尼编码" align="center">
          <template slot-scope="scope">          
            <span class="textOverflow">{{ scope.row.aoni }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="notes" label="物料描述" align="center">
          <template slot-scope="scope">          
            <el-tooltip class="item" effect="dark" :content="scope.row.notes"
              placement="top" min-width="100px" :open-delay="300">
              <div class="textOverflow">{{ scope.row.notes }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="createDateTime" label="创建时间" align="center">
          <template slot-scope="scope">          
            <span class="textOverflow">{{ scope.row.createDateTime }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="lastUpdateDateTime" label="最后更新时间" align="center">
          <template slot-scope="scope">          
            <span class="textOverflow">{{ scope.row.lastUpdateDateTime }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination :pagination="pagination"
        @currentChange="currentChange"
        @sizeChange="sizeChange"
        @refreshBtn="onSearch"
      ></pagination>    
      <input ref="uploadBlueWayFidInput" type="file"
        @change="uploadBlueWayFidChange()" style="display: none"/>
    </div>
    <div class="tableView" v-else>
      <el-table key="blueWayStockRecord" stripe :data="tableData" border style="width: 100%" height="100%" size="mini"
        @sort-change="sortChange" @selection-change="handleSelectionChange" :span-method="objectSpanMethod"
      >
        <el-table-column type="index" :width="pagination.endIndex >= 1000 ? 80 : 50"
          align="center" :index="pagination.beginIndex"
        ></el-table-column>
        <el-table-column prop="sapOrderNum" min-width="120px" label="SAP单号" align="center">
          <template slot-scope="scope">          
            <span class="textOverflow">{{ scope.row.sapOrderNum }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="aoniItemCode" min-width="140px" label="奥尼编码" align="center">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.maktx" class="item" effect="dark" :content="scope.row.maktx"
              placement="top" :open-delay="300"
            >
              <span class="textOverflow">{{ scope.row.aoniItemCode }}</span>
            </el-tooltip>
            <span v-else>{{ scope.row.aoniItemCode }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bdmng" min-width="80px" label="需求数量" align="center">
          <template slot-scope="scope">
              <span class="textOverflow">{{ scope.row.bdmng }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bdmng" min-width="100px" label="已备数量" align="center">
          <template slot-scope="scope">
            <span v-if="!scope.row.bdmng">-</span>
            <span v-else class="textOverflow" :class="[{yiguoqi: (scope.row.countQty>0 && scope.row.countQty != scope.row.bdmng)}, {pass: scope.row.countQty == scope.row.bdmng}]">{{ scope.row.countQty ? scope.row.countQty : '待备料' }}{{ scope.row.countQty > scope.row.bdmng ? "(溢)" : (scope.row.countQty>0 && scope.row.bdmng-scope.row.countQty > 0 ? ("(缺"+(scope.row.bdmng-scope.row.countQty)+")") : "")}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="blueWayItemCode" min-width="140px" label="外协工厂编码" align="center">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.notes" class="item" effect="dark" :content="scope.row.notes"
              placement="top" :open-delay="300"
            >
              <span class="textOverflow">{{ scope.row.blueWayItemCode }}</span>
            </el-tooltip>
            <span v-else>{{ scope.row.blueWayItemCode ? scope.row.blueWayItemCode : '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="aoniGrn" min-width="150px" label="奥尼GRN" align="center">
          <template slot-scope="scope">
              <span class="textOverflow">{{ scope.row.aoniGrn ? scope.row.aoniGrn : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reel" min-width="165px" label="外协工厂GRN" align="center">
          <template slot-scope="scope">
              <span class="textOverflow">{{ scope.row.reel ? scope.row.reel : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="qty" label="检料数量" align="center">
          <template slot-scope="scope">
            <span class="textOverflow">{{ scope.row.qty ? scope.row.qty : '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="checked" label="标签校验" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.checked" class="textOverflow pass">已校验</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="stockNum" min-width="150px" label="出库单号" align="center">
          <template slot-scope="scope">          
            <span class="textOverflow">{{ scope.row.stockNum ? scope.row.stockNum :'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="lotNum" min-width="120px" label="检料单号" align="center">
          <template slot-scope="scope">
              <span class="textOverflow">{{ scope.row.lotNum ? scope.row.lotNum : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="producedDate" label="检料日期" align="center">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.createDateTime" class="item" effect="dark" :content="scope.row.createDateTime"
              placement="top" :open-delay="300"
            >
              <span class="textOverflow">{{ scope.row.createDateTime}}</span>
            </el-tooltip>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="createUser" label="检料员" align="center">
          <template slot-scope="scope">
            <el-tooltip v-if="scope.row.createUser" class="item" effect="dark" :content="scope.row.createUser.name +'('+scope.row.createUser.employeeNum+')'"
              placement="top" :open-delay="300"
            >
              <span class="textOverflow">{{ scope.row.createUser.name }} ({{ scope.row.createUser.employeeNum }})</span>
            </el-tooltip>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>

import pagination from "@/components/pagination.vue";
import {
  apiBlueWayItemCodeSearch, apiBlueWayOrderSearch, apiBlueWayStockRecordSearch
} from "@/api/blueWay.js";

import { apiUploadFile } from "@/api/filesUpload.js";
import {apiBlueWayItemCodeUpdate} from "@/api/blueWay.js";
export default {
  components: {
    pagination
  },
  props: {
    blueWaySearchForm: {
      type: Object,
    },
  },
  data() {
    return {
      tableVal: "itemCode",
      tableData: [],
      desc: true,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      multipleSelection: [],
    };
  },
  watch: {
    tableVal: function() {
      this.onSearch();
    }
  },
  methods: {
    // 表格行合并
    objectSpanMethod({ row, columnIndex }) {
      // columnIndex: 1-5列需要合并
      if (columnIndex >= 1 && columnIndex <= 5) {
        if (row.rowspan) {
          return {
            // 几行合一
            rowspan: row.rowspan,
            // 几列合一
            colspan: 1
          };
        } else {
          return {
            // 为0不合,且该单元格会消失
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    async changeTab(value) {
      this.tableData = [];
      this.tableVal = value;
    },
    clickAllowSkip(row) {
      this.blueWaySearchForm.sapOrderId=row.id;
      this.$parent.twoTabPaneValue="blueWayStockRecord";
      this.tableVal = "blueWayStockRecord";
    },
    // 表格数据
    async onSearch() {
      this.tableData= [];
      if (this.tableVal == "blueWayItemCode") {
        const res = await apiBlueWayItemCodeSearch({
          ...this.blueWaySearchForm,
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          desc: this.desc,
          orderBy: this.orderBy
        });
        if (res.code == 0) {
          this.tableData = res.data;
          this.pagination.total = res.total;
          this.pagination.beginIndex = res.beginIndex;
          this.pagination.endIndex = res.endIndex;
        }
      } else if (this.tableVal == "blueWayOrder") {
        const res = await apiBlueWayOrderSearch({
          ...this.blueWaySearchForm,
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          desc: this.desc,
          orderBy: this.orderBy
        });
        if (res.code == 0) {
          this.tableData = res.data;
          this.pagination.total = res.total;
          this.pagination.beginIndex = res.beginIndex;
          this.pagination.endIndex = res.endIndex;
        }
      } else if (this.tableVal == "blueWayStockRecord") {
        const res = await apiBlueWayStockRecordSearch({
          ...this.blueWaySearchForm,
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
          desc: this.desc,
          orderBy: this.orderBy});
        if (res.code == 0) {
          this.tableData = res.data;
          let obj = {};
          let qty = {};
          res.data.forEach(item => {
            if (obj[item.sapOrderNum+":"+item.aoniItemCode+":"+item.bdmng]) {
              obj[item.sapOrderNum+":"+item.aoniItemCode+":"+item.bdmng] += 1;
              qty[item.sapOrderNum+":"+item.aoniItemCode+":"+item.bdmng] +=item.qty;
            } else {
              obj[item.sapOrderNum+":"+item.aoniItemCode+":"+item.bdmng] = 1;
              qty[item.sapOrderNum+":"+item.aoniItemCode+":"+item.bdmng] = item.qty;
            }
          });
          res.data.forEach(item => {
            if (obj[item.sapOrderNum+":"+item.aoniItemCode+":"+item.bdmng]) {
              item.rowspan = obj[item.sapOrderNum+":"+item.aoniItemCode+":"+item.bdmng];
              obj[item.sapOrderNum+":"+item.aoniItemCode+":"+item.bdmng] = 0;
              item.countQty = qty[item.sapOrderNum+":"+item.aoniItemCode+":"+item.bdmng];
            } else {
              item.rowspan = 0;
              item.countQty = 0;
            }
          });
        }
      }
    },
    uploadFileBtn() {      
      this.$nextTick(() => {
        this.$refs.uploadBlueWayFidInput.click();
      });
    },
    async uploadBlueWayFidChange() {
      let files = this.$refs.uploadBlueWayFidInput.files;
      if (files.length) {
        let fd = new FormData();        
        fd.append("file", files[0]);
        let res = await apiUploadFile(fd);
        if (res.code == 0) {
          this.$refs.uploadBlueWayFidInput.value = "";
          const resBind = await apiBlueWayItemCodeUpdate({
            id: res.fid,
          });
          if (resBind.code == 0) {
            this.$message({
              type: "success",
              message: `外协工厂物料编码上传成功！`,
            });
            this.onSearch();
          }
        }
      }
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {};
      this.$refs.fileUpload.value = "";
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.onSearch();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.onSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.onSearch();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  },
};
</script>

<style lang="less" scoped>
.yiguoqi {
  margin-right: 3px;
  color: #f56c6c
}
.pass {
  margin-right: 3px;
  color: #67C23A
}
.adasRecord {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.item {
  margin-right: 2px;
  margin-left: 2px;
}
.tableView {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
